export default {
      id: "metric-text-usage",
      viewBox: "0 0 19 15",
      url: "assets/" + "sprite.svg#metric-text-usage",
      toString: function () {
        return this.url;
      }
    }